<!--
 * @Author: wh
 * @Date: 2020-07-03 11:10:22
 * @LastEditTime: 2022-11-24 13:23:36
 * @LastEditors: 任赛赛 5595670+ren_sai_sai_sai@user.noreply.gitee.com
 * @Description: In User Settings Edit
 * @FilePath: \JiYun_Mobile_test\src\views\salesTerminal\retailAccount\fileUpload.vue
-->
<template>
    <div class="fileUpload">
        <van-nav-bar
            :title="title"
            left-text=""
            left-arrow
            @click-left="onClickLeft"
        ></van-nav-bar>
        <section class="van-pull-refresh">
            <div class="upload-con">
                <van-uploader
                    multiple
                    preview-image
                    preview-full-image
                    v-model="fileList"
                    :after-read="uploadFileMethod"
                    @delete="handleRemove"
                    :show-upload="true"
                    :deletable="!isView"
                    :disabled="isView"
                    :class="{'is-view': isView}"
                ></van-uploader>
            </div>
        </section>
        <!-- 加载层 -->
        <van-overlay :show="showOverlay">
            <van-loading type="spinner"></van-loading>
        </van-overlay>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
        return {
            // 表单数据
            formData: {},
            fileList: [],
            // 流程实例id
            BusinessInstanceId: '',
            // 附件列表源数据
            fileListSource: [],
            // 只读
            isView: false,
            // 标题
            title: '',
            // 加载层
            showOverlay: false,
            aliyunOssToken: null,
            buCode: 'ProductionAffix',
        };
    },
    watch: {},
    computed: {},
    methods: {
        // 上传文件
        async uploadFileMethod() {
            if (this.fileList.length === 0) {
                return;
            }
            // 如果没有文件分组 先创建文件分组
            if (!this.filesGroupId) {
                this.upGroupFun();
            }
            this.$nextTick(() => {
                this.fileList.forEach((item, i) => {
                    if (!item.fileId) {
                        this.upGroupFun(item, i);
                    }
                });
            });
        },
        // 返回上级页面
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.replace({
                name: this.$route.params.fromPath,
                params: { formData: this.formData, actionType: 'uploadFile' },
            });
            this.$router.go(-1);
        },
        // 获取上传通行证
        getOssToken() {
            this.$axios.get(this.GLOBAL.FILE_BASE_URL_OSS + `credential/GetPostPolicy/${this.buCode}`).then(res => {
                if (res) {
                    this.aliyunOssToken = res;
                    // localStorage.setItem('aliyunOssToken', JSON.stringify(res));
                }
            });
        },
        // 上传组名
        upGroupFun(val, i) {
            const filename = val ? val.file.name : '现场照片';
            // 判断是否过期，过期重新调用获取通信证方法
            const formData = new FormData();
            // 注意formData里append添加的键的大小写
            formData.append('key', `${this.aliyunOssToken.dir}${this.BusinessInstanceId}/${filename}`); // 存储在oss的文件路径
            formData.append('OSSAccessKeyId', this.aliyunOssToken.accessid); // accessKeyId
            formData.append('policy', this.aliyunOssToken.policy); // policy
            formData.append('Signature', this.aliyunOssToken.signature); // 签名
            // 如果是base64文件，那么直接把base64字符串转成blob对象进行上传就可以了
            formData.append('file', val ? val.file : filename);
            // formData.append('FileDescription', this.newFile.FileDescription);
            formData.append('success_action_status', 200); // 成功后返回的操作码
            formData.append('Content-Type', 'multipart/form-data'); // 成功后返回的操作码

            // 回调参数
            const obj = {
                bucket: this.aliyunOssToken.bucket ? this.aliyunOssToken.bucket : this.buCode, // 存储桶名称
                business_type_code: this.buCode, // 业务类型编码
                object_name: `${this.aliyunOssToken.dir}${this.BusinessInstanceId}/${filename}`, // 文件对象名
                show_name: filename, // 显示文件名
                size: val ? val.file.size : 0, // 文件大小
                mimeType: '',
                mime_type: val ? val.file.type : '',
                data_id: this.BusinessInstanceId, // 业务数据id
                directory_id: '', // 目录id
                tenant_id: this.$takeTokenParameters('TenantId'), // 租户id
                // FileDescription: this.newFile.FileDescription, // 文件描述
            };
            this.uploadFun(formData, obj, i);
        },
        // 上传文件
        uploadFun(formData, val, i) {
            this.$.ajax({
                url: this.aliyunOssToken.host,
                type: 'POST',
                data: formData,
                cache: false, // 不缓存数据
                processData: false, // 不处理数据
                contentType: false, // 不设置内容类型
                success: data => { // 成功回调
                    this.callBackFun(val, i);
                },
            });
        },
        // 上传的回调
        callBackFun(obj, i) {
            this.$axios.post(this.GLOBAL.FILE_BASE_URL_OSS + 'api/UploadCallback', obj).then(res => {
                if (res) {
                    if (i) {
                        this.fileList[i].fileId = res.id;
                    }
                    this.uploadFirm(res.id, res);
                }
            });
        },
        // 上传成功，添加文件
        uploadFirm(AFI_Code, fileData) {
            this.$axios
                .post('/interfaceApi/basicplatform/simpleflow/filegroupinstance', {
                    FileID: '',
                    FileName: fileData.file_name,
                    FileExt: '',
                    FileSize: fileData.file_size,
                    FileType: 2,
                    FileSort: 0,
                    FileDescription: '',
                    ParentID: '0',
                    BusinessType: '',
                    KeyID: this.BusinessInstanceId,
                    AFI_Code: AFI_Code,
                } )
                .then(res => {
                    if (res) {
                        this.fileListSource.push(res);
                    }
                })
                .catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 获取文件列表
        async getFileList() {
            if (this.BusinessInstanceId) {
                // 1.先获取所有文件夹和文件
                try {
                    const url = this.GLOBAL.FILE_BASE_URL_OSS + `api/GetFileList/${this.BusinessInstanceId}`;
                    const fileDataArr = await this.$axios.get(url);
                    fileDataArr.forEach(item => {
                        if (item.show_name === '现场照片') {
                            this.filesGroupId = item.id;
                        } else {
                            this.fileList.push({
                                fileId: item.id,
                                url: '',
                            });
                        }
                    });
                    this.$nextTick(() => {
                        this.getFileDetailFun(this.fileList);
                    });
                    // eslint-disable-next-line no-empty
                } catch (e) {}
            }
        },
        // 获取文件下载预览地址
        getFileDetailFun(data) {
            const arr = data;
            arr.forEach(item => {
                this.$axios
                    .get(this.GLOBAL.FILE_BASE_URL_OSS + 'api/GetFileInfo/' + item.fileId)
                    .then(res => {
                        item.url = res.preview_url;
                    })
                    .catch(error => {
                        this.$message.error(error.ErrorCode.Message);
                    });
            });
            this.fileData = arr;
        },
        // 文件上传到本地缓存
        onChangeFile(file, fileList) {
            this.fileList = fileList;
        },
        // 文件删除
        handleRemove(file) {
            let delIndex = null;
            const _that = this;
            for (const index in this.fileList) {
                if (file === this.fileList[index]) {
                    delIndex = index;
                    break;
                }
            }
            if (delIndex !== null) {
                this.fileList.splice(delIndex, 1);
                if (file.fileId) {
                    this.$axios
                        .delete(this.GLOBAL.FILE_BASE_URL_OSS + 'api/DeleteFileInfo/' + file.fileId, {
                        })
                        .then(() => {
                            _that.$message({
                                message: '删除成功！',
                                type: 'success',
                            });
                        })
                        .catch(error => {
                            _that.$message.error(error.ErrorCode.Message);
                        });
                }
            }
        },
    },
    created() {
        this.BusinessInstanceId = this.$route.params.BusinessInstanceId;
        this.isView = this.$route.params.isView || false;
        this.formData = this.$route.params.formData;
        this.title = this.$route.params.title;
        const aliy = localStorage.getItem('aliyunOssToken') ? JSON.parse(localStorage.getItem('aliyunOssToken')) : null;
        const date = new Date();
        if (aliy && aliy.expire && aliy.expire * 1000 > date.getTime()) {
            this.aliyunOssToken = aliy;
        } else {
            this.getOssToken();
        }
        this.getFileList();
    },
    mounted() {
    },
};
</script>
<style lang="stylus">
.fileUpload
    .van-pull-refresh
        height 100%
        .upload-con
            height 100%
            padding 15rpx
            .van-uploader__wrapper--disabled
                opacity 1
            .is-view
                .van-uploader__upload
                    display none
            .van-uploader__preview
                background rgba(240,240,240,1)
                display flex
                justify-content center
                .van-uploader__preview-image
                    vertical-align top
    .van-overlay
        .van-loading
            position absolute
            z-index 100
            top 50%
            left 50%
</style>
